import React, { Component } from 'react'

/**
 * Styles
 */
import './EventRegistrationForm.css'

/**
 * Modules
 */
import { Modal, Select, Input, message, Button, Form, Switch, Spin } from 'antd';
import { getPaymentCheckPhotoUrl, addPaymentCheckPhoto, addEventParticipant, updateEventParticipant } from '../../../utils/competitorsFunctions';

import { getAuth, onAuthStateChanged } from 'firebase/auth';

class EventRegistrationForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isUserLoggedIn: false,
            studentAddObjectNome: '',
            studentAddObjectFaixa: '',
            studentAddObjectEquipe: '',
            studentAddObjectFile: undefined,
            studentAddDisabledButton: false,
            loading: false,
            initialValue: [{}, {}, {}],
            confirmedPayment: false,

            loadingUpdate: false,
            hasFile: false,
            loadingFile: true,
        }
    }

    componentDidMount = () => {
        this.getFormData();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.competitorToUpdate && (JSON.stringify(this.props.competitorToUpdate) !== JSON.stringify(prevProps.competitorToUpdate)))
            this.getFormData();
    }

    getFormData = async () => {
        this.setState({ loadingFile: true })

        // Check if user is conected
        const auth = getAuth();
        onAuthStateChanged(auth, user => {
            if (user) {
                this.setState({ isUserLoggedIn: true })
            }
        });

        this.setState({
            studentAddObjectNome: '',
            studentAddObjectFaixa: '',
            studentAddObjectEquipe: '',
            studentAddObjectFile: undefined,
            studentAddDisabledButton: false,
            loading: false,
            initialValue: [{}, {}, {}]
        })

        if (this.props.competitorToUpdate) {
            // Check if payment was made
            let url = await getPaymentCheckPhotoUrl(this.props.competitorToUpdate.__key);
            this.setState({
                urlOfComprovante: url,
                hasFile: true,
                loadingFile: false,
                studentAddObjectFile: { name: this.props.competitorToUpdate.checkingCopyName ? this.props.competitorToUpdate.checkingCopyName : 'Arquivo sem nome' }
            });

            this.setState({
                initialValue: [
                    { initialValue: this.props.competitorToUpdate['nome'] },
                    { initialValue: this.props.competitorToUpdate['faixa'] },
                    { initialValue: this.props.competitorToUpdate['equipe'] },
                ],
                studentAddObjectNome: this.props.competitorToUpdate['nome'],
                studentAddObjectFaixa: this.props.competitorToUpdate['faixa'],
                studentAddObjectEquipe: this.props.competitorToUpdate['equipe'],
                confirmedPayment: this.props.competitorToUpdate['confirmedPayment']
            })
        } else {
            this.setState({ loadingFile: false })
        }
    }

    addFieldValue = (field, value) => {
        if (field === 'nome') {
            this.setState({
                studentAddObjectNome: value
            })
        }
    }

    addFieldValueFaixa = (value) => {
        this.setState({
            studentAddObjectFaixa: value
        })
    }

    addFieldValueEquipe = (value) => {
        this.setState({
            studentAddObjectEquipe: value
        })
    }

    chooseFile = () => {
        document.getElementById('selectCompetitorFile').click()
    }

    getFile = (file) => {
        this.setState({
            studentAddObjectFile: file.target.files[0],
            hasFile: true,
        })
    }

    removeFile = () => {
        this.setState({
            studentAddObjectFile: undefined,
            hasFile: false
        })
    }

    createStudent = async (event, eventId) => {
        /* Disable button until a response from firebase */
        this.setState({ loading: true })

        /* Get the file to put in firebase */
        const localFile = this.state.studentAddObjectFile

        if (
            this.state.studentAddObjectNome !== '' &&
            this.state.studentAddObjectFaixa !== '' &&
            this.state.studentAddObjectEquipe !== '' &&
            localFile !== undefined
        ) {

            let localStudentToPush = {
                nome: this.state.studentAddObjectNome,
                faixa: this.state.studentAddObjectFaixa,
                equipe: this.state.studentAddObjectEquipe,
                wasDeleted: false,
                momentOfCreation: new Date().getTime(),
                confirmedPayment: false,
                checkingCopyName: localFile.name
            }

            let idOfStudentAddedInEvent = ''

            /* Push competitor in firebase event */
            let studentAddedInEvent = await addEventParticipant(eventId, localStudentToPush);
            idOfStudentAddedInEvent = studentAddedInEvent.key;

            /* Push photo in firebase */
            if (localFile !== undefined)
                await addPaymentCheckPhoto(idOfStudentAddedInEvent, localFile);

            /* Put real key in student on event */
            await updateEventParticipant(eventId, idOfStudentAddedInEvent, { realKey: idOfStudentAddedInEvent });

            this.setState({
                loading: false,
                studentAddObjectFile: null,
                hasFile: false
            })

            message.success('Inscrição realizada com sucesso')

            /* Clear form */
            this.props.form.resetFields();

            this.props.updateStudentList();
        } else {
            this.setState({ loading: false })
            message.error('Todos os dados são obrigatórios')
        }
    }

    checkPayment = (value) => {
        this.setState({ confirmedPayment: value })
    }

    updateCompetitor = async (event, key, eventId) => {
        this.setState({ loadingUpdate: true })
        if (
            this.state.studentAddObjectNome !== '' &&
            this.state.studentAddObjectFaixa !== '' &&
            this.state.studentAddObjectEquipe !== '' &&
            this.state.studentAddObjectFile !== undefined
        ) {

            let localStudentToUpdate = {
                nome: this.state.studentAddObjectNome,
                faixa: this.state.studentAddObjectFaixa,
                equipe: this.state.studentAddObjectEquipe,
                confirmedPayment: this.state.confirmedPayment,
                checkingCopyName: this.state.studentAddObjectFile.name
            }

            /* Update competitor in firebase event */
            await updateEventParticipant(eventId, key, localStudentToUpdate);

            message.success('Atualização realizada com sucesso')
            this.setState({ loadingUpdate: false, hasFile: false })

            /* Clear form */
            this.props.form.resetFields();

            this.props.updateStudentList();
        } else {
            this.setState({ loadingUpdate: false })
            message.error('Todos os dados são obrigatórios')
        }
    }

    deleteCompetitor = (event, key, eventId) => {
        let _this = this

        Modal.confirm({
            title: 'Tem certeza que deseja excluir esse participante?',
            content: 'Essa operação não poderá ser desfeita',
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Não',
            async onOk() {
                /* Delete competitor in firebase event */
                await updateEventParticipant(eventId, key, { wasDeleted: true });

                _this.props.closeModal();
                message.success('Exclusão realizada com sucesso');

                _this.props.updateStudentList();
            }
        })
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form layout='horizontal'>
                    <Form.Item style={{ width: '100%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('name', this.state.initialValue[0])(
                            <Input
                                placeholder="Nome do participante"
                                onChange={e => this.addFieldValue('nome', e.target.value)}
                                className='sharedInput'
                                // style={{ width: '66%', marginRight: '2%', marginBottom: '10px' }}
                                id='registrationInputNameId'
                            />
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginRight: '2%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('faixa', this.state.initialValue[1])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Faixa do aluno"
                                optionFilterProp="children"
                                onChange={this.addFieldValueFaixa}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputFaixaId'
                            >
                                <Select.Option value={null}> </Select.Option>
                                <Select.Option value="whiteSmoke">Branca</Select.Option>
                                <Select.Option value="grey">Cinza</Select.Option>
                                <Select.Option value="yellow">Amarela</Select.Option>
                                <Select.Option value="orange">Laranja</Select.Option>
                                <Select.Option value="green">Verde</Select.Option>
                                <Select.Option value="#ffcc99">Colorido</Select.Option>
                                <Select.Option value="blue">Azul</Select.Option>
                                <Select.Option value="purple">Roxa</Select.Option>
                                <Select.Option value="brown">Marrom</Select.Option>
                                <Select.Option value="black">Preta</Select.Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item style={{ width: '49%', marginBottom: '10px', float: 'left' }}>
                        {getFieldDecorator('equipe', this.state.initialValue[2])(
                            <Select
                                showSearch
                                className='sharedInput'
                                placeholder="Equipe do aluno"
                                optionFilterProp="children"
                                onChange={this.addFieldValueEquipe}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                id='registrationInputEquipeId'
                            >
                                <Select.Option value={null}> </Select.Option>
                                {
                                    this.props.arrayOfTeams.map(team => {
                                        return (
                                            <Select.Option key={team.nome} value={team.nome}>{team.nome}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </Form.Item>

                    {this.state.loadingFile ?
                        <Spin style={{ width: '100%', marginTop: '10px' }} /> :
                        <div>
                            <input id='selectCompetitorFile' type='file' style={{ display: "none" }} onChange={(input) => this.getFile(input)} />
                            {this.state.hasFile ?
                                <div>
                                    <div
                                        className='RegistrationFormFileButton'
                                        onClick={() => window.open(this.state.urlOfComprovante, '_blank').focus()}
                                    >
                                        {this.state.studentAddObjectFile.name}
                                    </div>
                                    <div
                                        className='RegistrationFormFileButton'
                                        onClick={this.removeFile}
                                        style={{ width: '18%', marginLeft: '2%' }}
                                    >
                                        Remover
                                    </div>
                                </div>
                                :
                                <Button
                                    onClick={() => this.chooseFile()}
                                    style={{ width: '100%', float: 'left', marginTop: '4px' }}
                                    htmlType='button'
                                >
                                    Inserir comprovante
                                </Button>
                            }
                        </div>
                    }

                    <div style={{ clear: 'both' }}></div>

                    {this.props.competitorToUpdate ?
                        <div>
                            {
                                this.state.isUserLoggedIn ?
                                    <div style={{ lineHeight: '40px', marginTop: '20px' }}>
                                        <Switch defaultChecked={this.props.competitorToUpdate.confirmedPayment} onChange={this.checkPayment} /> Confirmar pagamento <br />
                                    </div>
                                    : null
                            }

                            <Button
                                type="primary"
                                loading={this.state.loadingUpdate}
                                htmlType='button'
                                onClick={() => this.updateCompetitor(this.props.eventInfo, this.props.competitorToUpdate.__key, this.props.eventId)}
                                style={{ marginTop: '10px', width: '49%', marginRight: '2%' }}
                            >
                                Atualizar
                            </Button>

                            <Button
                                type="danger"
                                htmlType='button'
                                onClick={() => this.deleteCompetitor(this.props.eventInfo, this.props.competitorToUpdate.__key, this.props.eventId)}
                                style={{ marginTop: '10px', width: '49%' }}
                            >
                                Deletar
                            </Button>

                            <div style={{ clear: 'both' }}></div>

                        </div>
                        :
                        <div>
                            <Button
                                type="primary"
                                loading={this.state.loading}
                                htmlType='button'
                                onClick={() => this.createStudent(this.props.eventInfo, this.props.eventId)}
                                style={{ marginTop: '10px', width: '100%' }}
                            >
                                Confirmar
                            </Button>
                        </div>
                    }

                    <div className='RegistrationFormPagseguroButton'>
                        {/* INICIO DO BOTAO PAGSEGURO */}
                        <a href="javascript:void(0)" onClick={() => window.PagSeguroLightbox('AA08060D060649199466EF831B86F042')}>
                            <img src="//assets.pagseguro.com.br/ps-integration-assets/botoes/pagamentos/160x20-pagar.gif" alt="Pague com PagSeguro - é rápido, grátis e seguro!" />
                        </a>
                        {/*  FIM DO BOTAO PAGSEGURO */}
                    </div>
                </Form>
            </div>
        )
    }
}

export default Form.create()(EventRegistrationForm)